var exports = {
  "k": "xe533113f--0018d0--container",
};

module.exports = exports;
